export default "__VITE_ASSET__CYzBSaK3__"